import React from "react";
import { useStaticQuery, graphql } from "gatsby";

const query = graphql`
  query Skills {
    allAirtable(
      filter: { table: { eq: "Skills" } }
      sort: { fields: data___order, order: ASC }
    ) {
      nodes {
        data {
          title
          value
          stack
        }
      }
    }
  }
`;

const Skills = () => {
  const {
    allAirtable: { nodes: skills },
  } = useStaticQuery(query);

  return (
    <section className={`section skills`}>
      <div className="section-title">
        <h2>skills</h2>
        <div className="underline"></div>
      </div>

      <div className={`section-center skills-center`}>
        <article>
          <h3>front end</h3>
          {skills.map((skill, index) => {
            const { title, value, stack } = skill.data;
            return (
              stack === "frontend" && (
                <div key={index} className="skill">
                  <p>{title}</p>
                  <div className="skill-container">
                    <div className={`skill-value value-${value}`}></div>
                    <p className={`skill-text skill-text-${value}`}>{value}%</p>
                  </div>
                </div>
              )
            );
          })}
        </article>
        <article>
          <h3>back end</h3>
          {skills.map((skill, index) => {
            const { title, value, stack } = skill.data;
            return (
              stack === "backend" && (
                <div key={index} className="skill">
                  <p>{title}</p>
                  <div className="skill-container">
                    <div className={`skill-value value-${value}`}></div>
                    <p className={`skill-text skill-text-${value}`}>{value}%</p>
                  </div>
                </div>
              )
            );
          })}

          <h3>mobile</h3>
          {skills.map((skill, index) => {
            const { title, value, stack } = skill.data;
            return (
              stack === "mobile" && (
                <div key={index} className="skill">
                  <p>{title}</p>
                  <div className="skill-container">
                    <div className={`skill-value value-${value}`}></div>
                    <p className={`skill-text skill-text-${value}`}>{value}%</p>
                  </div>
                </div>
              )
            );
          })}
        </article>
      </div>
    </section>
  );
};

export default Skills;
